export default {
  computed: {
    canClose() {
      return !this.$store.state.closingDisabled && this.notProcessingRegistration;
    },

    notProcessingRegistration() {
      return !(this.registration && this.registration.state == "processing");
    },
  },
};
